import { useState } from 'react';
import { useRangeCriteria } from './useRangeCriteria';

export interface Props {
  width: {
    from: string;
    to: string;
  };
  height: {
    from: string;
    to: string;
  };
  length: {
    from: string;
    to: string;
  };
}

export const useMeasurementsCriteria = ({ width, height, length }: Props) => {
  const { handleOnChange: handleRangeOnChange } = useRangeCriteria({
    first_value: width.from,
    second_value: width.to,
  });

  const [formData, setData] = useState({
    width: {
      first_value: width.from,
      second_value: width.to,
    },
    height: {
      first_value: height.from,
      second_value: height.to,
    },
    length: {
      first_value: length.from,
      second_value: length.to,
    },
  });

  const handleOnChange = (input: Props) => {
    setData({
      width: handleRangeOnChange({
        first_value: input.width.from,
        second_value: input.width.to,
      }),
      height: handleRangeOnChange({
        first_value: input.height.from,
        second_value: input.height.to,
      }),
      length: handleRangeOnChange({
        first_value: input.length.from,
        second_value: input.length.to,
      }),
    });
    return {
      width: handleRangeOnChange({
        first_value: input.width.from,
        second_value: input.width.to,
      }),
      height: handleRangeOnChange({
        first_value: input.height.from,
        second_value: input.height.to,
      }),
      length: handleRangeOnChange({
        first_value: input.length.from,
        second_value: input.length.to,
      }),
    };
  };

  return {
    formData,
    handleOnChange,
  };
};
